import { render, staticRenderFns } from "./CommonGroup.vue?vue&type=template&id=f693fe16&scoped=true"
import script from "./CommonGroup.vue?vue&type=script&lang=js"
export * from "./CommonGroup.vue?vue&type=script&lang=js"
import style0 from "./CommonGroup.vue?vue&type=style&index=0&id=f693fe16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f693fe16",
  null
  
)

export default component.exports